import {Dimension, END, Pair, START} from '../abstract-units';
import {Cell} from '../cell';
import {BOX_EDGES_BY_AXIS, BoxEdge, Edge, EdgeSides, Side} from '../edge';
import {AxisEdgesWalker} from './axis-edges-walker';

export class SideCellsWalker {
    public cells: Cell[];

    private edge: Edge;
    private side: Side;

    constructor(edge: Edge, side: Side) {
        this.edge = edge;
        this.side = side;
        this.cells = edge.sides[side];
    }

    public axisEdges(axis?: Dimension): AxisEdgesWalker {
        if (axis === undefined) {
            axis = this.edge.axis;
        }

        const cellCount = this.cells.length;
        const boxEdges: Pair<BoxEdge> = BOX_EDGES_BY_AXIS[axis];
        const edges: Edge[] = this.cells.map(cell => cell.edges[boxEdges[START]]);

        if (cellCount) {
            const lastCell = this.cells[cellCount - 1];

            edges.push(lastCell.edges[boxEdges[END]]);
        }

        return new AxisEdgesWalker(edges, axis);
    }

    public crossAxisEdges(): AxisEdgesWalker {
        return this.axisEdges(this.edge.movingAxis);
    }

    public splitByEdge(edge: Edge): EdgeSides {
        const cells = this.cells;
        const splitIndex = this.axisEdges(edge.axis).edges.indexOf(edge);

        return [
            cells.slice(splitIndex, cells.length),
            cells.slice(0, splitIndex)
        ];
    }
}
